import {TicketListResultVo} from '../../common/shared/api/nicolas/vo/TicketListResultVo.interface';
import {ContentTicketInfo} from '../generated/types';
import {createTicketInfoApi} from './TicketInfoApi';

export function createContentTicketInfo({
  own_ticket_list = [],
  rental_ticket_list = [],
  is_sale_own_ticket,
  is_sale_rental_ticket,
  rental_period_by_minute,
}: TicketListResultVo): ContentTicketInfo {
  return {
    isSaleOwnTicket: is_sale_own_ticket,
    isSaleRentalTicket: is_sale_rental_ticket,
    purchasableOwnTicketList: own_ticket_list.map(createTicketInfoApi),
    purchasableRentalTicketList: rental_ticket_list.map(createTicketInfoApi),
    rentalPeriodByMinute: rental_period_by_minute,
  };
}
